export const ITEM_OUTCOME_OVERRIDE_UPDATE = 'itemOutcomeOverrideUpdate' as const;
export const ITEM_OUTCOME_OVERRIDE_DELETE = 'itemOutcomeOverrideDelete' as const;
export const ITEM_OUTCOME_HIDE_ACTION = 'itemOutcomeHideAction' as const;
export const ITEM_OUTCOME_UNHIDE_ACTION = 'itemOutcomeUnhideAction' as const;

export const ItemOutcomeActions = Object.freeze({
  ITEM_OUTCOME_OVERRIDE_UPDATE,
  ITEM_OUTCOME_OVERRIDE_DELETE,
  ITEM_OUTCOME_HIDE_ACTION,
  ITEM_OUTCOME_UNHIDE_ACTION,
});

export default ItemOutcomeActions;
